module.exports = __webpack_public_path__ + "img/cd.4346647b.svg";